import {Component} from '@angular/core';

@Component({
  selector: 'app-ts-v2-talent-pool-section',
  templateUrl: './talent-pool-section.component.html',
  styleUrls: ['./talent-pool-section.component.scss'],
})
export class V2TalentPoolSectionComponent {
  dataPoints = [
    {icon: '💰', titleKey: 'talentSearchV2.talentPool.dp1Title', descKey: 'talentSearchV2.talentPool.dp1Desc'},
    {icon: 'svg:sa-flag', titleKey: 'talentSearchV2.talentPool.dp2Title', descKey: 'talentSearchV2.talentPool.dp2Desc'},
    {icon: '📍', titleKey: 'talentSearchV2.talentPool.dp3Title', descKey: 'talentSearchV2.talentPool.dp3Desc'},
    {icon: '📞', titleKey: 'talentSearchV2.talentPool.dp4Title', descKey: 'talentSearchV2.talentPool.dp4Desc'},
  ];
}
